import { BullhornFileTypes, BullhornListTypes, BullhornNamespace } from 'datasource-service-lib';
import { IFileDataSourceApiService } from 'interfaces-lib';
import { IIconService } from 'interfaces-lib';
import { IWorkflowService } from 'interfaces-lib';
import { INamedEntityService } from 'named-entity-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IFileListViewConfig } from '../../file-list-view/file-list-view.component';
import { IFileListProvider } from '../../interfaces/ifilelistprovider';
import { OkLocalFileChecker } from '../../interfaces/localfilechecker';
import { ServiceProviderService } from '../service.provider.service';
import { BullhornFileToPathConverter } from './bullhorn.filetopathconverter';

export class BullhornFileListViewConfig implements IFileListViewConfig {
  readonly namespace = BullhornNamespace.name;
  readonly fileDataSourceApiService: IFileDataSourceApiService;
  readonly workflowService: IWorkflowService;
  readonly namedEntityService: INamedEntityService;
  readonly iconService: IIconService;
  readonly fileToPathConverter = new BullhornFileToPathConverter(BullhornListTypes.FileAttachments);
  readonly localFileChecker = OkLocalFileChecker;
  readonly fileListProvider: IFileListProvider;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    const dataSourceApiService = serviceProviderService.getDataSourceApiService(BullhornNamespace.name);
    this.fileListProvider = {
      dataSourceApiService: dataSourceApiService,
      listType: BullhornListTypes.FileAttachments,
      fileType: BullhornFileTypes.FileAttachment,
    };
    this.fileDataSourceApiService = sharedServiceProviderServiceFactory.getServiceProviderService(BullhornNamespace.name).getFileDataSourceApiService();
    this.workflowService = serviceProviderService.getWorkflowService(BullhornNamespace.name);
    this.namedEntityService = sharedServiceProviderServiceFactory.getServiceProviderService(BullhornNamespace.name).getNamedEntityService();
    this.iconService = serviceProviderService.getIconService(BullhornNamespace.name);
  }
}
